import { render, staticRenderFns } from "./nav-app-business.vue?vue&type=template&id=43e8a48c"
import script from "./nav-app-business.vue?vue&type=script&lang=js"
export * from "./nav-app-business.vue?vue&type=script&lang=js"
import style0 from "./nav-app-business.vue?vue&type=style&index=0&id=43e8a48c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports